import React, { useEffect, useReducer } from 'react'
import brandLogo from "../Assets/navbarLogo.webp"
import smallBoxBg from "../Assets/smallMovingBox.webp"
import roundBoxBg from "../Assets/lightHotpinkShape.webp"
import "../fontawesome6/pro/css/all.min.css"
import { NavLink } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

export default function Navigation() {

  const homeNavigate = useNavigate();

  const initialstate = {
    dropdownClass:"",
    navIconClass:"fa-sharp fa-regular fa-bars fa-lg",
  }

 
 const reducer = (state , action) => {
       switch(action.type){
        case "NAVIGATION" : 
        if(state.dropdownClass === ""){
          return {...state,dropdownClass:"openMenu" , navIconClass:"fa-regular fa-xmark"}
        }
        else{
          return {...state,dropdownClass:"" , navIconClass:"fa-sharp fa-regular fa-bars fa-lg"}
        }

        default : 
        throw new Error();
       }
 }


  const [state , dispatch] = useReducer(reducer , initialstate);

  const handleNavigation = () => {
     dispatch({
      type:"NAVIGATION"
     });
  }

  const handleStickyNav = () => {
    if(window.pageYOffset>10){
      document.body.classList.add("sticky");
    }
    else{
      document.body.classList.remove("sticky");
    }
  }


  useEffect(() => {
    window.addEventListener("scroll" , handleStickyNav);

    return () => {
      window.removeEventListener("scroll" , handleStickyNav)
    }
  })

  const handleHome = () => {
      homeNavigate("/");
  }


  return (
    <>
      <div className="navigation">
        <div className="navbar">
          <div className="navbar-brand" onClick={handleHome}>
          <img src={brandLogo} alt="img" />
          </div>
          <nav>
            <ul>
              <li><NavLink to="/">HOME</NavLink></li>
              <li><NavLink to="/about">ABOUT</NavLink></li>
              <li><NavLink to="/services">SERVICES</NavLink></li>
              <li><NavLink to="/projects">PROJECTS</NavLink></li>
              <li><NavLink to="/team">TEAM</NavLink></li>
              <li><NavLink to="/contact">CONTACT</NavLink></li>
 
            </ul>
            <button>
            <i className="fa-light fa-phone-rotary fa-xl"></i>
            +98 222 4444</button>
            <div className="nav-btn" onClick={handleNavigation}>
            <i className={`${state.navIconClass}`}></i>
            </div>
          </nav>
          {/* Dropdown menu started */}
          <div className={`dropDownMenu ${state.dropdownClass}`}>
            <ul>
            <li><NavLink to="/">HOME</NavLink></li>
              <li><NavLink to="/about">ABOUT</NavLink></li>
              <li><NavLink to="/services">SERVICES</NavLink></li>
              <li><NavLink to="/projects">PROJECTS</NavLink></li>
              <li><NavLink to="/team">TEAM</NavLink></li>
              <li><NavLink to="/contact">CONTACT</NavLink></li>
            </ul>
          </div>
        </div>
      </div>
      <figure className='navbox-BgImg'>
        <img src={smallBoxBg} alt="" />
        </figure>
        <figure className='navbox-HotpinkShapeImg'>
        <img src={roundBoxBg} alt="" />
        </figure>
    </>
  )
}
